import { Link } from "react-router-dom";
import styled from "styled-components";

export const SingleNewsPageContainer = styled.div`
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  max-width: 1240px;
  padding: 200px 5px 0px 5px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    max-width: 90%;
  }
`;
export const SinglePageMainImg = styled.img`
  width: 100%; 
  max-width: 1920px; 
  height: 100%; 
  max-height: 1820px;
  margin-bottom: 15px;
  object-fit: cover;
`;

export const SingleNewsPageTitle = styled.div`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 600;
  font-size: 48px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  background: linear-gradient(227deg, #373839 0%,  #01b75c 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  max-width: 250px;
`;

export const SingleNewsContentArea = styled.div`
  width: 82%;
  position: relative;
  padding: 30px 20px 20px 0px;

  @media (max-width: 1100px) {
    width: 100%;
    margin: 0 auto;

    border-bottom: 1px solid #000;
   
  }
`;

export const SingleNewsPageBody = styled.div`
  position: relative;
  display: flex;
  min-height: 100vh;
  border-bottom: 1px solid #000;
  margin-top: 35px;
  gap: 50px;

  @media (max-width: 1100px) {
  flex-wrap: wrap;
    gap: 0;

      border-top: 0;
  border-bottom: 0;
  }
`;

export const SingleNewsSection = styled.div`
  margin-bottom: 15px;
`;

export const SingleNewsSectionBody = styled.div`
  display: flex;
  flex-direction: column;
  margin: 14px 0 0 0;

`;

export const SectionText = styled.div`
  a  {
    display: inline-block;
    margin: 0 5px;
    color: #6ea5ec;
   }
    
  p {
    font-family: "e-Ukraine", sans-serif;
    font-weight: 300;
    font-size: 16px;
    line-height: 116%;
    color: #202020;
    margin: 20px 0;
  }
`;
export const SectionTitle = styled.div`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 116%;
  letter-spacing: 0.02em;
  color: #202020;
  margin: 30px 0 15px 0;
`;

/*----- sidebar  ----*/

export const NewsSidebar = styled.div`
  width: 30%;
  padding: 30px 0px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    width: 40%;
    padding: 30px 0px 50px 0;
  }

  @media (max-width: 1100px) {
    width: 100%;
  }

 
`;

export const NewsSidebarHeader = styled(Link)`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  cursor: pointer;

  &:hover {
    div {
        transition: color 0.3s ease-in-out;
      color:  #01b75c;
    }

    img {
        transition: filter 0.3s ease-in-out;
      filter: invert(39%) sepia(45%) saturate(479%) hue-rotate(305deg) 
        brightness(94%) contrast(94%);
    }
  }
`;


export const SidebarHeaderTitle = styled.div`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 116%;
  letter-spacing: 0.02em;
  color: #202020;
`;
export const SidebarHeaderIcon = styled.img`
`;

export const SidebarNewsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 1100px) {
    display: grid; 
    grid-template-columns: repeat(2, 1fr); 
    gap: 30px;
  }
`;

export const SidebarNewsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;

  @media (max-width: 1100px) {
    &:nth-child(7) {
      display: none;
    }
  }
`;

export const NewsDate = styled.div`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 120%;
  letter-spacing: 0.02em;
  color: #696d6d;
`;

export const SidebarNewsTitle = styled(Link)`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
  line-height: 116%;
  letter-spacing: 0.02em;
  color: #000;
  max-width: 250px;
  transition: color 0.3s ease;

  &: hover {
    color:  #01b75cі;
  }

  @media (max-width: 1024px){
    font-size: 14px;
  }
  @media (max-width: 768px){
    font-size: 11px;
  }
`;
